import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';

interface Props {
  children: React.ReactNode;
}

const FlashWarning: React.FC<Props> = ({ children }) => (
  <div
    className="mb-[30px] flex flex-col mt-2.5 text-lg font-medium leading-5"
    data-test-flash-message="warning"
  >
    <div
      className={clsx(
        'py-3 px-6 rounded bg-[#DAE4EF] text-[#000000b3] mx-auto max-w-[600px]',
        'self-center text-center whitespace-pre-line border-[3px] border-solid',
        'border-[#F5A623] bg-[#F5A623]',
      )}
    >
      {children}
    </div>
  </div>
);

export default observer(FlashWarning);
